import ClockoutController from '../../core/clockout.controller';
import Inherit from '../../core/inherit';
import { setAuthCookie } from '../../utils/cookies';
import LoginDelegate from './login.delegate';

/**
 * @extends ClockoutController
 * @extends LoginDelegate
 */
class LoginController extends Inherit(ClockoutController, LoginDelegate) {
    async initialize() {
        // Check if user has valid data (not just an empty object)
        if (this.user && this.user.access && this.user.access.length > 0) {
            this.navigateDashboard();
            return;
        }

        // Check if there's a token in the URL for invitation validation
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        
        if (token) {
            this.setState({ showResetPassword: true });
        }

        // Listen for password reset completion
        this.handlePasswordResetComplete = () => {
            this.setState({ showResetPassword: false });
        };
        window.addEventListener('passwordResetComplete', this.handlePasswordResetComplete);
    }

    async cleanup() {
        // Remove event listener when component unmounts
        if (this.handlePasswordResetComplete) {
            window.removeEventListener('passwordResetComplete', this.handlePasswordResetComplete);
        }
    }

    async authenticateUser() {
        try {
            this.setState({ loading: true });
            const response = await this.data.loginUser(this.state);
            
            if (response?.token) {
                setAuthCookie(response.token);
                this.constructor._notifyAuthChange(); // Notify all components
                this.navigateDashboard();
            }
        } catch (error) {
            this.setState({ error: true });
        } finally {
            this.setState({ loading: false });
        }
    }
}

export default LoginController;
